import store from "../store";

export function setServiceRegistry(){
    store.dispatch({
        type:"setServiceRegistry",
        payload:{}
    })
}
